<bn-loading-overlay></bn-loading-overlay>
<h5>Questionário FGEnergia</h5>
<div class="container">
  <div [formGroup]="pesquisaForm">
    <div class="row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light align-self-end" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto mt-0" style="margin-top: -0.5%">
      <button #focusableSubmit type="button" [disabled]="pesquisaForm.invalid"
                class="btn btn-success align-self-end"
                (click)="buscar(false, true)">Pesquisar</button>
      </div>
    </div>

    <div class="row align-items-center">
      <div class="mb-3 col-md-3">
        <label><b>CNPJ: </b></label>
        <input type="text"  bnMask="cnpj" class="form-control"  formControlName="cnpjCliente" (keydown.enter)=" pesquisaForm.valid && buscar(false, true)" >
      </div>
      <div class="mb-3 col-md-6">
        <label><b>Token: </b></label>
        <input  type="text"  class="form-control" formControlName="token" (keydown.enter)="pesquisaForm.valid && buscar(false, true)">
      </div>
      <div class="bn-form-group col-md-3">
        <label><b>Estado: </b></label>
        <ng-select
          [items]="estados"
          bindLabel="nome"
          bindValue="valor"
          placeholder="Todos"
          formControlName="ideEstado"
        >
        </ng-select>
      </div>
    </div>
  </div>
</div>
<app-questionario-fgenergia-listagem
  [questionarios]="questionarios"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  (aoMudarPagina)="mudancaPagina($event)"
  (aoExcluirQuestionario)="excluirQuestionario($event)">
</app-questionario-fgenergia-listagem>
